export const urls = {
    getCoupons: userId => `/api/coupons/list/${userId}`,
    applyCoupon: () => '/api/coupons/apply'
};

export const initialState = {
    data: null,
    metadata: {},
    isFetching: false,
    isError: false
};

const transformGetData = data => {
    return {
        data: data.data,
        metadata: data.meta,
        isFetching: false,
        isError: false
    };
};

// const transformAppendGetData = (data, state) => {
//     const notifications = state.data ? state.data : [];
//     const newData = [
//         ...notifications,
//         ...data.data
//     ];

//     return {
//         data: newData,
//         metadata: data.meta,
//         isFetching: false,
//         isError: false
//     };
// };

const transformRequestData = state => {
    const data = state.data;
    const metadata = state.metadata ? state.metadata : {};

    return {
        data,
        metadata,
        isFetching: true,
        isError: false
    };
};

const transformErrorData = state => {
    const data = state.data ? state.data : [];
    const metadata = state.metadata ? state.metadata : {};

    return {
        data,
        metadata,
        isFetching: false,
        isError: true
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_COUPONS':
            return transformGetData(action.data);
        case 'REQUEST_COUPONS':
            return transformRequestData(state);
        case 'ERROR_COUPONS':
            return transformErrorData(state);
        default:
            return state;
    }
};
